import { render } from "./odn-modal-languages.vue?vue&type=template&id=3abd4129"
import script from "./odn-modal-languages.vue?vue&type=script&lang=js"
export * from "./odn-modal-languages.vue?vue&type=script&lang=js"

import "./odn-modal-languages.vue?vue&type=style&index=0&id=3abd4129&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__